// eslint-disable-next-line
import React from 'react' // Needed for styled() Extends

import styled from 'styled-components'
import { Row } from 'styles/account'
export const Header = styled(Row)`
  align-items: space-between;
  border-bottom: 1px solid ${(props) => props.theme.colors.borderLight};
  padding: 15px 0;
  margin: 0 0 50px;
  h1 {
    color: ${(props) => props.theme.colors.default};
    font-size: 30px;
    font-weight: 400;
    margin: 0;
    width: 50%;
    flex-grow: 1;
    @media (max-width: ${(props) => props.theme.breakpoints[0]}) {
      font-size: 24px;
    }
  }
  @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
    border: none;
    flex-direction: column;
    align-items: flex-start;
    h1 {
      flex-grow: 1;
      width: 100%;
      max-width: initial;
      padding-bottom: 10px;
      margin: 15px 0 10px;
      border-bottom: 1px solid ${(props) => props.theme.colors.borderLight};
    }
  }
`